import { PrivateRoutes } from '@/constants/routes'
import { Tab, Tabs } from '@nextui-org/react'
import React, { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom'
import ListCardLegacy from './ListCardLegacy'
import TablePrincipalLegacy from './TablePrincipalLegacy'
import TableCustodyLegacy from './TableCustodyLegacy'
import TableRetiradosLegacy from './TableRetiradosLegacy'
import TableRecibidosLegacy from './TableRecibidosLegacy'
import { useSelector } from 'react-redux'
import { motion } from 'framer-motion'
import { IConfigSeller } from '@/models/configSeller'
import { loadMacstoreChat } from '@/utils/loadMacstoreChat'

const HomePageLegacy: React.FC = () => {
  const { pathname } = useLocation()
  const userState = useSelector((store: any) => store.user)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isSamsungPeru = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe'
  const isHuaweiOnlineChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_cl'
  const isHuaweiOnlineMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_mx'
  const isHuaweiOnlinePeru = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_pe'
  const isChatEnabled = configSeller.config.permisos.ENABLE_CHATBOT

  const { slug } = useParams()

  useEffect(() => {
    const cleanup = isChatEnabled ? loadMacstoreChat(configSeller.config.s3.FOLDER_APP) : undefined
    return () => {
      cleanup?.()
      document.getElementById('webchat-container')?.remove()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, isChatEnabled])

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.3 }} className='space-y-4'
    >
      {[Number(import.meta.env.VITE_PERFIL_SOLOLECTURA), Number(import.meta.env.VITE_PERFIL_ADMIN), Number(import.meta.env.VITE_PERFIL_TI_REGION), Number(import.meta.env.VITE_PERFIL_JEFETIENDA), Number(import.meta.env.VITE_TI_JEFETIENDA_SELLOS), Number(import.meta.env.VITE_PERFIL_EJECUTIVO), Number(import.meta.env.VITE_PERFIL_EJECUTIVO_CUSTODIA), Number(import.meta.env.VITE_PERFIL_EJECUTIVO_CAJA), Number(import.meta.env.VITE_PERFIL_ADMIN_SELLER)].includes(userState.id_role) ? <ListCardLegacy /> : null}
      <div className='bg-white rounded-2xl shadow-md p-2 mt-4'>
        <Tabs selectedKey={pathname} aria-label='Tabs' size='lg' className={[Number(import.meta.env.VITE_PERFIL_CUSTODIA)].includes(userState.id_role) ? '!hidden' : ''}>
          <Tab className='text-tiny px-1 md:px-3' id={PrivateRoutes.HOME.replace(':slug', String(slug))} key={PrivateRoutes.HOME.replace(':slug', String(slug))} href={PrivateRoutes.HOME.replace(':slug', String(slug))} title='Principal' />
          {![Number(import.meta.env.VITE_PERFIL_TI_COTIZADOR)].includes(userState.id_role) && !isSamsungPeru && !isHuaweiOnlineChile && !isHuaweiOnlineMexico && !isHuaweiOnlinePeru ? <Tab className='text-tiny px-1 md:px-3' id={PrivateRoutes.RECIBIDOS.replace(':slug', String(slug))} key={PrivateRoutes.RECIBIDOS.replace(':slug', String(slug))} href={PrivateRoutes.RECIBIDOS.replace(':slug', String(slug))} title='Equipos recibidos' /> : null}
          {[Number(import.meta.env.VITE_PERFIL_SOLOLECTURA), Number(import.meta.env.VITE_PERFIL_ADMIN), Number(import.meta.env.VITE_PERFIL_TI_REGION), Number(import.meta.env.VITE_PERFIL_JEFETIENDA), Number(import.meta.env.VITE_TI_JEFETIENDA_SELLOS)].includes(userState.id_role) && !isSamsungPeru && !isHuaweiOnlineChile && !isHuaweiOnlineMexico && !isHuaweiOnlinePeru ? <Tab className='text-tiny px-1 md:px-3' id={PrivateRoutes.ENCUSTODIA.replace(':slug', String(slug))} key={PrivateRoutes.ENCUSTODIA.replace(':slug', String(slug))} href={PrivateRoutes.ENCUSTODIA.replace(':slug', String(slug))} title='Equipos custodia' /> : null}
          {[Number(import.meta.env.VITE_PERFIL_SOLOLECTURA), Number(import.meta.env.VITE_PERFIL_ADMIN), Number(import.meta.env.VITE_PERFIL_TI_REGION), Number(import.meta.env.VITE_PERFIL_JEFETIENDA), Number(import.meta.env.VITE_TI_JEFETIENDA_SELLOS)].includes(userState.id_role) && !isSamsungPeru && !isHuaweiOnlineChile && !isHuaweiOnlineMexico && !isHuaweiOnlinePeru ? <Tab className='text-tiny px-1 md:px-3' id={PrivateRoutes.RETIRADOS.replace(':slug', String(slug))} key={PrivateRoutes.RETIRADOS.replace(':slug', String(slug))} href={PrivateRoutes.RETIRADOS.replace(':slug', String(slug))} title='Equipos retirados' /> : null}
        </Tabs>
        <Routes>
          <Route path='/' element={[Number(import.meta.env.VITE_PERFIL_CUSTODIA)].includes(userState.id_role) ? <TableRecibidosLegacy /> : <TablePrincipalLegacy />} />
          <Route path='/recibidos' element={<TableRecibidosLegacy />} />
          <Route path='/custodia' element={<TableCustodyLegacy />} />
          <Route path='/retirados' element={<TableRetiradosLegacy />} />
          <Route path='/*' element={<Navigate replace to={PrivateRoutes.HOME} />} />
        </Routes>
      </div>
    </motion.div>
  )
}

export default HomePageLegacy
